'use client';

import Link from '@eliadmin/core/src/components/link';
import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { useRegisterLayout } from '@eliadmin/core/src/components/dlz/auth/register/register-card';
import { CheckboxField } from '@eliadmin/core/src/components/dlz/auth/register/register-fields';
import type { Persona } from '@eliadmin/core/src/components/dlz/auth/register/register-schema';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { getDefaultUrlForTosOrGdprLocalized } from '@eliadmin/core/src/utils/misc-utils';

const LINK =
  'rounded-sm text-[#D7191F] transition-colors hover:text-[#B5141A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012]';

/**
 * Figma 60260:28849 / 60260:30123: the required consent (terms and personal data – both flags of
 * the API), for companies the request for a company account, the optional newsletter.
 */
export function Consents({ persona }: { persona: Persona }) {
  const dialog = useRegisterLayout() === 'dialog';
  const locale = useLocaleStore(state => state.currentLocale);
  const copy = REGISTER_COPY.consents;
  const isCompany = persona === 'company';

  return (
    <div className={cn('flex flex-col gap-3', dialog && 'border-t border-[#E2E4E7] pt-6')}>
      <CheckboxField name="consent" required>
        {copy.termsPrefix}
        <Link
          href={getDefaultUrlForTosOrGdprLocalized(ROUTES.TOS?.() ?? '/', locale, 'tos')}
          target="_blank"
          prefetch={false}
          className={LINK}
        >
          {copy.terms}
        </Link>
        {copy.termsJoin}
        <Link
          href={getDefaultUrlForTosOrGdprLocalized(ROUTES.GDPR?.() ?? '/', locale, 'gdpr')}
          target="_blank"
          prefetch={false}
          className={LINK}
        >
          {copy.privacy}
        </Link>
        <span aria-hidden="true" className="text-[#D7191F]">
          {' *'}
        </span>
      </CheckboxField>
      {isCompany ? (
        <CheckboxField name="business_account">{copy.businessAccount}</CheckboxField>
      ) : null}
      <CheckboxField name="newsletter">
        {isCompany ? copy.newsletterCompany : copy.newsletterIndividual}
      </CheckboxField>
    </div>
  );
}
